import { format } from 'date-fns';
import { INotification } from '@partiu/api/notifications/types';

export const DAY_LABELS: Record<string, string> = {
  monday: 'Segunda',
  tuesday: 'Terça',
  wednesday: 'Quarta',
  thursday: 'Quinta',
  friday: 'Sexta',
  saturday: 'Sábado',
  sunday: 'Domingo',
};

export function scheduleLabel({ type, date, daysOfWeek, time }: Pick<INotification, 'type' | 'date' | 'daysOfWeek' | 'time'>) {
  if (type === 'recurring') return `${daysOfWeek.map((day) => DAY_LABELS[day]).join(', ')} às ${time}`;
  return date ? format(new Date(date), "dd/MM/yyyy 'às' HH:mm") : '-';
}
